let production = false;
let devMode = true;
let domain = 'https://api.pkubezpieczenia.com';

let suffix = '/api';

if(!production && devMode) {
  suffix = '/app_dev.php/api';
}

if(!production && !devMode) {
  suffix = '/app.php/api';
}

let url = domain + suffix;

export function apiUrl() {
  'ngInject';
  return {
    API_URL: url
  };
}



// WEBPACK FOOTER //
// ./client/app/app.api.config.js